<template>
    <div v-if="screen.active" class="menu" ref="menu">
        <div v-if="state == 'select'" class="select">
            <ul class="list">
                <li v-for='artist in artists' :key="artist.key" @click="selectArtist(artist.key)" :style="{backgroundImage : `url('${getIcon(artist.icon)}')`}">
                    <div class="label">
                        <h1>{{artist.name}}</h1>
                    </div>
                </li>
            </ul>
        </div>
        <div v-else-if="state == 'info'" class="info modal">
            <h1>{{selectedArtist.name}}</h1>
            <img class="select-image"  @click="enter" :src="getIcon(selectedArtist.icon)" alt="">
            <div class="artist-bio">
                <h1>ARTIST BIO</h1>
                <p>{{selectedArtist.bio}}</p>
            </div>
            <button class="button-default" @click="enter">{{confirm}}</button>
        </div>
        
    </div>
</template>

<style scoped>

    ul {
        padding: 0;
    }

    .menu {
       background-color :rgba(255, 255, 255, 0.5);
       z-index : 1;
       position: absolute;
       width: 100%;
       height: 100%;
       align-items: center;
       text-align: center;
       z-index: 2;
    }

    .menu-item{
        width : 100%;
        height : 100%;
        background-color: blue;
        grid-column: span 2;
        grid-row: span 2;
    }

    .select {
        overflow: hidden;
        height : 95%;
        padding-top: 75px;
        align-items: center;
        display: flex;
    }

    .list {
        width : 100vw;
        height : 100%;
        margin : auto;
        overflow-y: scroll;
        max-width: 1200px;
        display : grid;
        align-items: center;
        grid-template-columns: repeat(auto-fit, minmax(360px, 570px));
        grid-template-rows: repeat(autofit, 1fr);
        gap: 1rem;
        list-style: none;
    }

    .list::-webkit-scrollbar { width: 0 !important }
    .list > li {
        grid-column: span 1;
        grid-row: span 1;
        background-color: #C49E03 ;
        height: 100%;
        margin : 12px;
        border-radius: 12px;
        position: relative;
        background-size: cover;
        background-position-y: 0px;
        box-shadow:inset 0 0 0 2000px rgba(0, 0, 0, 0.15);
    }

    .list > li > img {
        position: absolute;
        left : 0;
        top : 0;
    }

    .select-image {
        width : 100%;
    }

    .info {
        background-color :white;
        position : absolute;
        z-index: 2;
        text-align: left;
        padding : 20px;
    }

    .label {
        color: white;
        position : absolute;
        bottom : 0;
        left : 2.0em;
        text-align: left;
    }
    .label > h1 {
        font-size: 2em;
        text-shadow: 2px 2px 10px #000000;
    }

    @media screen and (min-width: 600px) {
        .label > h1 {
            font-size: 3em;
        }
    }



    .menu-bg{
        background-color: white;
        opacity :0.5;
        width : 100vw;
        height: 100vh;
    }
</style>

<script>

import {gsap} from 'gsap'
export default {
    data : function() {
        return {
            state : 'select',
            selected : 'lmb',
            timeline : new gsap.timeline(),
            isMounted : false,
            css : {
                opacity : 0
            }
        }
    },

    computed : {
        screen : function(){
            return this.$store.state.screens.menu;
        },

        artists : function() {
            return this.$store.state.artists;
        },

        selectedArtist : function() {
            return this.artists.find(a => a.key == this.selected)
        },

        confirm : function(){
            return this.$store.state.screens.menu.confirm;
        },

        back : function(){
            return this.$store.state.back;
        },

        enterGallery : function(){
            return this.$store.state.enterGallery;
        }
    },

    watch : {
        back : function(){
            if(!this.screen.active) return;
            console.log('back from menu');
            this.onBack();
        },

        enterGallery : function(){
            if(!this.screen.active) return;
            this.$nextTick(() => this.show());
        }
    },

    methods : {
        getIcon(icon) {
            return `${require("@/assets/images/icons/" + icon)}`;
        },

        selectArtist(key) {
            this.selected = key;
            let isMobile = this.$store.state.environment.isMobile;
            //this.state = 'info';
            //console.log(require(`@/assets/images/textures/${this.selectedArtist.pano}`));
            this.$store.commit('load', {
                assets : [].concat(isMobile ? this.selectedArtist.mobile : this.selectedArtist.pano).map(a => { return a }),
                onComplete : () => this.enter()
            });

            if(isMobile) {
                this.$store.commit('requestAccelerometer');
            }
            //this.enter();
        },

        onBack(){
            if(this.state == 'info'){
                this.state = 'select';
            } else {
                //this.hide();
            }
        },

        hide(){
            this.$store.commit('hide', 'menu');
            this.state = 'select';
        },

        enter() {
            this.hide();
            this.$store.commit('setArtist', this.selected);
            this.$store.commit('enterRoom');
           
        },

        show(){
            this.timeline.clear();
            this.timeline.set(this.css, { opacity:0, onComplete : () => this.updateCSS()});
            this.timeline.to(this.css, 1, { opacity : 1,  onUpdate : () => this.updateCSS()});
        },

        updateCSS(){
            // let scale = this.vars.scale;
            // let x = this.vars.x;
            // let y = this.vars.y;
            if(!this.$refs.menu) return;
            let opacity = this.css.opacity;

            // let newTransform = `scale(${scale}) translate( ${x}%, ${y}% )`;
            // this.$refs.gallery.style.transform = newTransform;
            this.$refs.menu.style.opacity = opacity;
            // this.$refs.overlay.style.opacity = overlayOpacity;
        },
    },

    mounted() {
        this.$store.commit('checkPlatform');
    }
}
</script>